import { Helmet } from 'react-helmet-async'

type MetaTagsProps = {
  title: string
  description?: string
}

const MetaTags = ({ title, description }: MetaTagsProps) => {
  return (
    <Helmet>
      {title && <title>{title} | Riparide</title>}
      {description && <meta name="description" content={description} />}
    </Helmet>
  )
}

export default MetaTags
